import randomInt from '../utils/randomInt'

/**
 * Returns an array with two items chosen at random from the array passed in. If the array passed in
 * has fewer than three items, a copy of the array is returned unmodified.
 */
export default function pickTwoFromArr(arr) {
  const copy = [...arr]

  if (copy.length <= 2) {
    return copy
  }

  return [
    copy.splice(randomInt(0, copy.length), 1)[0],
    copy.splice(randomInt(0, copy.length), 1)[0],
  ]
}



// WEBPACK FOOTER //
// ./src/utils/pickTwoFromArr.js